import { useQuery } from '@tanstack/react-query';

import DealCrawlerService from '~/services/cruises/DealCrawlerService';

import { dealCrawlerQueryKeys } from './dealCrawlerQueryKeys';

const FETCH_PAGE_SIZE = 100;

export interface UseGetDealCrawlersListParams {
  /** When set, only crawlers for this vendor are returned. */
  vendorId?: string;
  /** When false, the query does not run (e.g. when modal is closed). */
  enabled?: boolean;
}

export function useGetDealCrawlersList({ vendorId, enabled = true }: UseGetDealCrawlersListParams = {}) {
  return useQuery({
    queryKey: dealCrawlerQueryKeys.list({ vendorId }),
    queryFn: ({ signal }) => {
      const params = {
        skip: 0,
        take: FETCH_PAGE_SIZE,
        ...(vendorId ? { vendorId } : {}),
      } as Parameters<typeof DealCrawlerService.listWithPagination>[0];
      return DealCrawlerService.listWithPagination(params, signal ? { signal } : undefined);
    },
    enabled,
  });
}

export { FETCH_PAGE_SIZE };
